module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "card card-indent mt-2"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row bg-primary-light"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "text-weight-normal mb-2"
  }, [_vm._v(_vm._s(_vm.labels.HEADING))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('p'), (_vm.formSubmitted && (!_vm.formValid || _vm.changePasswordError)) ? _c('div', {
    staticClass: "feedback",
    attrs: {
      "id": "feedbackPanel"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [(!_vm.passwordFilled) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_FIELD_REQUIRED) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.passwordIsStrong) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_STREIGHT_ERROR) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.passwordConfirmValid) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASS_DO_NOT_MATCH) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.changePasswordError && !_vm.linkExpired) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_CHANGE_ERROR) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.changePasswordError && !_vm.linkExpired) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_RESTRICTION_TEXT) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.linkExpired) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_CHANGE_LINK_EXPIRED) + "\n                    ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: " alert alert-success alert-dismissible"
  }, [_vm._v("\n                " + _vm._s(_vm.labels.SUCCESS_TEXT) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), (!_vm.isChangePasswordAllowed) ? _c('p') : _vm._e(), (!_vm.isChangePasswordAllowed) ? _c('div', {
    staticClass: " alert alert-danger alert-dismissible"
  }, [_vm._v("\n                " + _vm._s(_vm.labels.PASSWORD_WAS_SET) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.success && _vm.isChangePasswordAllowed) ? _c('form', {
    attrs: {
      "id": "id1",
      "method": "post",
      "name": "CredentialsForm",
      "action": ""
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "j_oldPassword"
    }
  }, [_vm._v(_vm._s(_vm.labels.PASSWORD))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.Password),
      expression: "credentials.Password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "value": "",
      "name": "pasword",
      "maxlength": "300"
    },
    domProps: {
      "value": (_vm.credentials.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.Password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "password-hint"
  }, [_c('h4', [_vm._v(_vm._s(_vm.labels.PASSWORD_REQUIREMENTS_TEXT))]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isLowercase, 'invalid': _vm.startPasswordCheck && !_vm.isLowercase
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.LOWERCASE_LETTER_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isUppercase, 'invalid': _vm.startPasswordCheck && !_vm.isUppercase
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.UPPERCASE_LETTER_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isNumber, 'invalid': _vm.startPasswordCheck && !_vm.isNumber
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.NUMBER_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isSpecial, 'invalid': _vm.startPasswordCheck && !_vm.isSpecial
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.SPECIAL_SYMBOL_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isLong, 'invalid': _vm.startPasswordCheck && !_vm.isLong
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_LENGTH_TEXT) + "\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.labels.CONFIRM_PASSWORD))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PasswordConfirm),
      expression: "PasswordConfirm"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "passwordConfirm",
      "type": "password",
      "size": "15",
      "value": "",
      "name": "passwordConfirm",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.PasswordConfirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PasswordConfirm = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group button-start"
  }, [(!_vm.linkExpired) ? _c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "saveButton"
    },
    on: {
      "click": _vm.createPassword
    }
  }, [_vm._v(_vm._s(_vm.labels.SAVE))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "cancelButton"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.labels.CANCEL))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-4"
  }, [_c('a', {
    attrs: {
      "href": "mailto:myfolbb.support@Folbb.com"
    }
  }, [_vm._v(_vm._s(_vm.labels.HELP))])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center text-gray-light my-4"
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-72 mmk-icon-account",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "position": "absolute",
      "left": "-100px",
      "top": "-100px",
      "overflow": "hidden"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "id1_hf_0",
      "id": "id1_hf_0"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e5238e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreatePassword/CreatePassword.vue
// module id = 185
// module chunks = 1